<ng-template #fileHeader>
  <header class="br-card-header workspace-collection-header br-flex-wrap br-px-3">
    <div class="br-flex br-items-center br-gap-2 br-min-w-0">
      <button type="button" class="file-tree-control br-btn br-btn--ghost br-icon-btn br-interactive" (click)="treeOpen = !treeOpen" [attr.aria-expanded]="treeOpen" aria-controls="file-folders" aria-label="Toggle folder sidebar"><br-icon>account_tree</br-icon></button>
      <div class="br-min-w-0">
        <h1 class="workspace-page__title">{{ parent?.name || areaLabel }}</h1>
      </div>
    </div>
    <div class="workspace-page__title-actions br-flex-wrap br-ms-auto br-justify-end">
      <span class="br-view-switch" role="group" aria-label="File view">
        <button type="button" class="br-view" [class.br-view--on]="layout === 'table'" [attr.aria-pressed]="layout === 'table'" (click)="layout = 'table'">
          <br-icon>view_list</br-icon> Table
        </button>
        <button type="button" class="br-view" [class.br-view--on]="layout === 'grid'" [attr.aria-pressed]="layout === 'grid'" (click)="layout = 'grid'">
          <br-icon>grid_view</br-icon> Grid
        </button>
      </span>
      <ng-container *ngIf="canManage">
      <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm workspace-collection-add" [disabled]="busy" (click)="creatingFolder = !creatingFolder" [attr.aria-expanded]="creatingFolder"><br-icon>create_new_folder</br-icon> New folder</button>
      <button type="button" class="br-btn br-btn--primary br-btn--sm workspace-collection-add" *ngIf="canUpload" [disabled]="busy" (click)="uploadInput.click()"><br-icon>upload</br-icon> Upload</button>
      </ng-container>
    </div>
  </header>
  <div *ngIf="creatingFolder || error || notice" class="br-card-header br-flex br-flex-column br-gap-2 br-small">
  <form *ngIf="creatingFolder" class="br-flex br-items-center br-gap-2" (ngSubmit)="createFolder()">
    <input class="br-form-control br-form-control--sm br-min-w-0" name="folderName" aria-label="Folder name" placeholder="Folder name" [(ngModel)]="folderName" maxlength="255" required>
    <button type="submit" class="br-btn br-btn--primary br-btn--sm" [disabled]="busy || !folderName.trim()">Create</button>
    <button type="button" class="br-btn br-btn--ghost" (click)="creatingFolder = false">Cancel</button>
  </form>
  <p *ngIf="error" class="br-alert br-alert--danger br-m-0" role="alert">{{ error }}</p>
  <p *ngIf="notice" class="br-m-0" role="status">{{ notice }}</p>
  </div>
</ng-template>
<input #uploadInput type="file" multiple hidden (change)="upload($event)">
<ng-template #fileActions let-file>
  <button type="button" class="br-btn br-btn--ghost br-icon-btn br-interactive" [brMenuTriggerFor]="fileMenu" [attr.aria-label]="'Actions for ' + file.name"><br-icon>more_horiz</br-icon></button>
  <ng-template #fileMenu>
    <br-menu aria-label="File actions">
      <button brMenuItem (triggered)="file.isFolder ? open(file) : inspect(file)" [label]="file.isFolder ? 'Open folder' : 'Details'" [icon]="file.isFolder ? 'folder_open' : 'visibility'"></button>
      <button brMenuItem *ngIf="file.isFolder" (triggered)="inspect(file)" label="Folder details" icon="info_outline"></button>
      <button brMenuItem *ngIf="canManage" [disabled]="busy" (triggered)="remove(file)" [label]="'Delete ' + (file.isFolder ? 'folder' : 'file')" icon="delete"></button>
    </br-menu>
  </ng-template>
</ng-template>
<ng-template #fileGallery>
  <ng-container *ngTemplateOutlet="fileHeader"></ng-container>
  <div class="br-card-body br-p-0 workspace-page__panel br-flex br-flex-column">
    <app-data-table *ngIf="layout === 'table'; else gridView" class="br-flex-grow-1"
                    [columns]="columns" [fetch]="fetch" [(search)]="search" [trackByFn]="trackFile"
                    [rowActions]="fileActions" [resizableColumns]="true" [initialQuery]="tableQuery"
                    (queryChange)="tableQuery = { sort: $event.sort, desc: $event.desc }"
                    searchPlaceholder="Search files and folders..." emptyText="No files or folders found.">
      <ng-template dtCell="name" let-file>
        <button type="button" class="br-btn br-btn--link br-btn--sm br-gap-2 br-interactive" (click)="open(file)" [title]="file.name"
                [draggable]="canManage && !busy" (dragstart)="startFileDrag($event, file)" (dragend)="endFileDrag()"
                [fileDropTarget]="file.isFolder ? { area: file.isShared ? 'shared' : 'personal', folder: file.id } : null"
                [canDropFile]="canDropFile" (fileDropped)="dropFile($event)">
          <app-file-thumbnail [file]="file"></app-file-thumbnail>{{ file.name }}
        </button>
        <span *ngIf="file.status && file.status !== 'Ready'" class="br-small br-text-muted">{{ file.status === 'Pending' ? 'Uploading...' : file.status }}</span>
      </ng-template>
      <ng-template dtCell="byteSize" let-file>
        {{ file.isFolder ? '—' : ((file.byteSize || 0) / 1024 | number:'1.0-1') + ' KB' }}
      </ng-template>
      <ng-template dtCell="uploadedByName" let-file>
        {{ file.isFolder ? '—' : (file.uploadedByName || (file.uploadedByUserId ? 'User #' + file.uploadedByUserId : '—')) }}
      </ng-template>
      <ng-template dtCell="uploadedAt" let-file>
        <time [attr.datetime]="file.uploadedAt">{{ !file.isFolder && file.uploadedAt ? (file.uploadedAt | date:'medium') : '—' }}</time>
      </ng-template>
    </app-data-table>
    <ng-template #gridView>
      <app-data-list [fetch]="fetch" [(search)]="search" layout="grid" [showLoading]="false" searchPlaceholder="Search files and folders..." [trackByFn]="trackFile"
                     [emptyText]="search ? 'No matching files or folders.' : canUpload ? 'No files yet. Drop files here or use Upload above (up to 1 GB per file).' : 'No files in this folder.'">
        <ng-template dataListItem let-file>
          <div class="file-grid-item br-flex br-items-center">
            <button type="button" class="file-grid-item__open br-btn br-interactive br-gap-2" [draggable]="canManage && !busy" (dragstart)="startFileDrag($event, file)" (dragend)="endFileDrag()"
                [fileDropTarget]="file.isFolder ? { area: file.isShared ? 'shared' : 'personal', folder: file.id } : null"
                [canDropFile]="canDropFile" (fileDropped)="dropFile($event)" (click)="open(file)" [attr.aria-label]="(file.isFolder ? 'Open folder ' : 'Download ') + file.name">
              <app-file-thumbnail [file]="file"></app-file-thumbnail>
              <span class="file-grid-item__name" [title]="file.name">{{ file.name }}</span>
              <span class="br-small br-text-muted" *ngIf="file.status && file.status !== 'Ready'">{{ file.status === 'Pending' ? 'Uploading...' : file.status }}</span>
            </button>
          </div>
        </ng-template>
      </app-data-list>
    </ng-template>
  </div>
</ng-template>
<ng-template #fileDetails>
  <section class="workspace-page br-compact-page file-detail" *ngIf="detail as d" [attr.aria-busy]="busy">
    <header class="workspace-page__heading">
      <h1 class="workspace-page__title" [title]="d.file.name">{{ d.file.name }}</h1>
      <div class="workspace-page__title-actions">
        <button type="button" class="br-btn br-btn--primary br-btn--sm" *ngIf="ready as revision" [disabled]="busy" (click)="download(d.file, revision)">
          <br-icon>download</br-icon> Download
        </button>
        <ng-container *ngIf="canManage">
          <button type="button" class="br-btn br-btn--ghost br-icon-btn br-interactive" [brMenuTriggerFor]="detailMenu" aria-label="More actions"><br-icon>more_vert</br-icon></button>
          <ng-template #detailMenu>
            <br-menu aria-label="File actions">
              <button brMenuItem [disabled]="busy" (triggered)="remove(d.file)" [label]="'Delete ' + (d.file.isFolder ? 'folder' : 'file')" icon="delete"></button>
            </br-menu>
          </ng-template>
        </ng-container>
        <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="closeDetail()"><br-icon>arrow_back</br-icon> Back</button>
      </div>
    </header>
    <p *ngIf="error" class="br-alert br-alert--danger br-m-0" role="alert">{{ error }}</p>
    <p *ngIf="notice" class="br-m-0" role="status">{{ notice }}</p>

    <section class="br-card br-card--dense">
      <header class="br-card-header file-panel__header">
        <h2 class="br-card-title">Details</h2>
        <ng-container *ngIf="canManage">
          <button *ngIf="!renaming" type="button" class="br-btn br-btn--ghost br-icon-btn" (click)="startRename()" matTooltip="Rename" aria-label="Rename"><br-icon>edit</br-icon></button>
          <ng-container *ngIf="renaming">
            <button type="button" class="br-btn br-btn--ghost br-icon-btn" [disabled]="busy || !editedName.trim()" (click)="saveName()" matTooltip="Save" aria-label="Save name"><br-icon>save</br-icon></button>
            <button type="button" class="br-btn br-btn--ghost br-icon-btn" (click)="cancelRename()" matTooltip="Cancel" aria-label="Cancel renaming"><br-icon>close</br-icon></button>
          </ng-container>
        </ng-container>
      </header>
      <div class="br-card-body">
        <dl class="file-facts">
          <dt>Name</dt>
          <dd *ngIf="!renaming">{{ d.file.name }}</dd>
          <dd *ngIf="renaming"><input class="br-form-control br-form-control--sm" aria-label="Name" [(ngModel)]="editedName" maxlength="255" (keyup.enter)="saveName()" (keyup.escape)="cancelRename()"></dd>
          <dt>Location</dt>
          <dd>{{ areaLabel }}<ng-container *ngIf="parent"> › {{ parent.name }}</ng-container></dd>
          <ng-container *ngIf="!d.file.isFolder">
            <dt>Type</dt>
            <dd>{{ typeLabel(d.file) }} · {{ (d.file.byteSize || 0) / 1024 | number:'1.0-1' }} KB</dd>
            <dt>Uploaded</dt>
            <dd>{{ d.file.uploadedByName || '—' }} · {{ d.file.uploadedAt ? (d.file.uploadedAt | date:'medium') : '—' }}</dd>
          </ng-container>
          <ng-container *ngIf="d.file.isFolder">
            <dt>Updated</dt>
            <dd>{{ d.file.updatedAt | date:'medium' }}</dd>
          </ng-container>
          <dt>Access</dt>
          <dd>{{ d.file.isShared ? 'Shared with company' : 'Only you' }}</dd>
        </dl>
      </div>
    </section>

    <ng-container *ngIf="!d.file.isFolder">
      <section class="br-card br-card--dense" aria-label="AI summary">
        <header class="br-card-header file-panel__header">
          <h2 class="br-card-title">AI summary</h2>
          <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="!ready || summarizing" (click)="summarize()">{{ summary ? 'Summarize again' : 'Summarize' }}</button>
        </header>
        <div class="br-card-body">
          <p *ngIf="summarizing" role="status" class="br-text-muted br-m-0">Summarizing...</p>
          <p *ngIf="summaryError" class="br-alert br-alert--danger br-m-0" role="alert">{{ summaryError }}</p>
          <p *ngIf="summary && !summarizing" class="file-summary">{{ summary }}</p>
          <p *ngIf="!summary && !summarizing && !summaryError" class="br-text-muted br-m-0">No summary yet</p>
        </div>
      </section>

      <section *ngIf="canRunOcr" class="br-card br-card--dense" aria-label="OCR">
        <header class="br-card-header file-panel__header">
          <h2 class="br-card-title">OCR</h2>
          <span class="br-flex br-gap-1">
            <button *ngIf="ocrActive && canManage" type="button" class="br-btn br-btn--ghost br-btn--sm" [disabled]="busy" (click)="refreshOcr()">Refresh</button>
            <button *ngIf="canManage" type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="busy || ocrActive" (click)="runOcr()">{{ currentOcr ? 'Run OCR again' : 'Run OCR' }}</button>
          </span>
        </header>
        <div class="br-card-body br-flex br-flex-column br-gap-2">
          <p *ngIf="processingError" class="br-alert br-alert--danger br-m-0" role="alert">{{ processingError }} <button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="retryProcessing()">Retry</button></p>
          <ng-container *ngIf="currentOcr as run; else noOcr">
            <p class="br-m-0" role="status">{{ run.status }} · {{ run.createdAt | date:'medium' }}</p>
            <p *ngIf="run.error" class="br-text-muted br-m-0">{{ run.error }}</p>
            <details *ngIf="run.text" open><summary>Extracted text</summary><pre class="file-ocr-text">{{ run.text }}</pre></details>
            <button *ngIf="!run.text && (run.status === 'Succeeded' || run.status === 'Partial')" type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="readProcessing(run)">Show extracted text</button>
          </ng-container>
          <ng-template #noOcr><p class="br-text-muted br-m-0">No OCR yet</p></ng-template>
          <details *ngIf="olderOcr.length">
            <summary>History ({{ olderOcr.length }})</summary>
            <div *ngFor="let run of olderOcr" class="file-history-row">
              <span>{{ run.createdAt | date:'medium' }} · {{ run.status }}</span>
              <button *ngIf="!run.text && (run.status === 'Succeeded' || run.status === 'Partial')" type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="readProcessing(run)">Show text</button>
              <pre *ngIf="run.text" class="file-ocr-text">{{ run.text }}</pre>
            </div>
          </details>
        </div>
      </section>

      <section *ngIf="canPreview" class="br-card br-card--dense" aria-label="Preview">
        <header class="br-card-header file-panel__header">
          <h2 class="br-card-title">Preview</h2>
          <button *ngIf="!previewUrl && ready as revision" type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="busy" (click)="preview(revision)">Show</button>
        </header>
        <div *ngIf="previewUrl" class="br-card-body br-p-0">
          <iframe class="file-preview" [src]="previewUrl" referrerpolicy="no-referrer" title="File preview"></iframe>
        </div>
      </section>

      <section class="br-card br-card--dense" aria-label="Versions">
        <header class="br-card-header file-panel__header">
          <h2 class="br-card-title">Versions</h2>
          <ng-container *ngIf="canManage && canUploadRevision">
            <input #revisionInput type="file" hidden (change)="upload($event, true)">
            <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="busy" (click)="revisionInput.click()"><br-icon>upload</br-icon> Upload</button>
          </ng-container>
        </header>
        <div class="br-card-body">
          <div *ngFor="let revision of d.revisions" class="file-history-row">
            <span>{{ revision.createdAt | date:'medium' }} · {{ revision.byteSize / 1024 | number:'1.0-1' }} KB<ng-container *ngIf="revision.status !== 'Ready'"> · {{ revision.status }}</ng-container></span>
            <button *ngIf="revision.status === 'Ready'" type="button" class="br-btn br-btn--ghost br-icon-btn" [disabled]="busy" (click)="download(d.file, revision)" matTooltip="Download" aria-label="Download version"><br-icon>download</br-icon></button>
          </div>
          <p *ngIf="d.hasMoreHistory" class="br-text-muted br-m-0">Showing the most recent 100 records.</p>
        </div>
      </section>
    </ng-container>
  </section>
</ng-template>
<ng-template #browser let-compact>
  <div class="file-workspace" [class.file-workspace--compact]="compact">
    <aside id="file-folders" class="file-sidebar" [class.file-sidebar--open]="treeOpen || !!draggedFile" aria-label="Folder sidebar">
      <button type="button" class="file-tree-control br-btn br-btn--ghost" (click)="treeOpen = false"><br-icon>close</br-icon>Close folders</button>
      <app-file-tree [area]="area" [folder]="parent" [revision]="treeRevision" [canDropFile]="canDropFile" (fileDropped)="dropFile($event)" (locationChange)="selectLocation($event)" (pathResolved)="showFolderTrail($event)"></app-file-tree>
    </aside>
    <app-workspace-master-detail [detailOpen]="!!detail">
      <section workspace-master class="br-card br-card--dense workspace-page workspace-page--full file-browser" [attr.aria-busy]="busy"
               (dragover)="dragOver($event)" (dragenter)="dragEnter($event)" (dragleave)="dragLeave($event)" (drop)="drop($event)">
        <div *ngIf="dragDepth > 0 && canUpload && !busy" class="file-drop-overlay" role="status"><br-icon>upload</br-icon>Drop files to upload to {{ parent?.name || areaLabel }}</div>
        <ng-container *ngTemplateOutlet="fileGallery"></ng-container>
      </section>
      <section workspace-detail><ng-container *ngTemplateOutlet="fileDetails"></ng-container></section>
    </app-workspace-master-detail>
  </div>
</ng-template>
<ng-container *workspaceView="'full'"><ng-container *ngTemplateOutlet="browser; context: {$implicit: false}"></ng-container></ng-container>
<ng-container *workspaceView="'compact'"><ng-container *ngTemplateOutlet="browser; context: {$implicit: true}"></ng-container></ng-container>
